// Per-(user, connection, database) UI preferences for the Objects panel.
// Currently: the chosen sort order ('alpha' | 'usage' | 'recent').
import { api } from './api.js';

const url = (connId, db) =>
  `/api/connections/${connId}/databases/${encodeURIComponent(db)}/prefs`;

export async function loadDbPrefs(connId, db) {
  try {
    return await api.get(url(connId, db));
  } catch {
    return { objectsSort: 'alpha' };
  }
}

export async function saveDbPrefs(connId, db, prefs) {
  try {
    await api.put(url(connId, db), prefs);
  } catch (_) {
    // optimistic — UI state already updated
  }
}

// Set the SHARED per-(connection, database) color cue (dev/prod tagging). Unlike
// the prefs above this is visible to everyone who uses the connection; the value
// is read back folded into GET …/databases (see Browser sidebar). '' clears it.
export async function setDatabaseColor(connId, db, color) {
  await api.put(
    `/api/connections/${connId}/databases/${encodeURIComponent(db)}/color`,
    { color }
  );
}
